module.exports = __webpack_public_path__ + "img/ready_to_use.acae2f83.svg";